<template>
  <div v-if="(Object.keys(site).length !== 0 && site.constructor === Object)">
    <b-row>
      <b-col>
        <b-card>
          <h1 class="mt-0 mb-0">
            {{ site.name }}
          </h1>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-tabs>
          <b-tab
            active
            title="Site Details"
          >
            <site-details
              class="mt-2"
              :site="site"
              @saveSiteDetails="saveSiteDetails"
            />
          </b-tab>

        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
import {
  BTabs,
  BTab,
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'
import SiteDetails from './SiteDetails/SiteDetails.vue'

import * as queries from '../../../graphql/queries'
import * as mutations from '../../../graphql/mutations'

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    SiteDetails,

  },
  data() {
    return {
      site: {},
      sensorData: [],
    }
  },
  created() {
    this.getSite()
  },
  methods: {
    // --- FUNCTIONS ---
    async getSite() {
      await API.graphql({
        query: queries.getSite,
        variables: {
          id: this.$route.params.id,
        },
      }).then(response => {
        if (!response.errors) {
          this.site = response.data.getSite
        }
      })
    },
    async saveSiteDetails(site) {
      await API.graphql({
        query: mutations.updateSite,
        variables: {
          input: {
            id: site.id,
            name: site.name,
            address: site.address,
            zip_code: site.zip_code,
            city: site.city,
            subRegion: site.subRegion,
            region: site.region,
            country: site.country,
            AWSLongLat: site.AWSLongLat,
          },
        },
      }).then(response => {
        if (!response.errors) {
          this.site = response.data.updateSite
        }
      })
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/pages/page-profile.scss';
kbd {
  color: #3e3434
}

</style>
